import { Box, Link, Typography } from '@mui/material';
import { MAIN_APP_URL } from '@/types';

export default function LayoutFooter() {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        textAlign: 'center',
        borderTop: 1,
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        mt: 'auto',
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.5,
          mb: 1,
        }}
        role="navigation"
        aria-label="法律資訊"
      >
        <Link
          href={`${MAIN_APP_URL}/privacy-policy`}
          variant="caption"
          color="text.secondary"
          underline="hover"
          sx={{ fontWeight: 500 }}
        >
          私隱政策
        </Link>
        <Typography component="span" variant="caption" color="text.disabled" sx={{ userSelect: 'none' }}>
          |
        </Typography>
        <Link
          href={`${MAIN_APP_URL}/terms-of-service`}
          variant="caption"
          color="text.secondary"
          underline="hover"
          sx={{ fontWeight: 500 }}
        >
          服務條款
        </Link>
      </Box>
      <Typography variant="caption" color="text.secondary" display="block" fontStyle="italic">
        © {year} Wong Tsz Ho。版權所有。
      </Typography>
    </Box>
  );
}
